import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from 'atoms/buttons/Button';
import { Container } from 'atoms/layout/Container';
import { Vertical } from 'atoms/layout/flex';
import { Cards, Layout } from 'components/cardswap/Layout';
import { Header } from 'components/cardswap/Layout/Header';
import { StepProps } from 'components/cardswap/types';

const CardWithLabel = styled(Vertical)`
  justify-content: center;
  text-align: center;
`;

const Label = styled.div`
  font: var(--t-12);
  font-weight: var(--t-bold);
  text-transform: uppercase;
  color: var(--c-static-neutral-500);
`;

const FlexedContainer = styled(Container)`
  flex: 1;
  align-items: center;
`;

type Props = StepProps & {
  cardToSwap: string;
  cardIdToReceive: string;
  renderCardToSwap: ReactNode;
  renderCardToReceive: ReactNode;
};

export const ConfirmSwap = ({
  cardToSwap,
  cardIdToReceive,
  renderCardToSwap,
  renderCardToReceive,
  completeTrade,
  nextStep,
}: Props) => {
  if (!cardToSwap || !cardIdToReceive) {
    return null;
  }
  return (
    <Layout
      main={
        <>
          <Header
            title={
              <FormattedMessage
                id="CardSwap.ConfirmSwap.title"
                defaultMessage="Complete your swap"
              />
            }
            subtitle={
              <FormattedMessage
                id="CardSwap.ConfirmSwap.subtitle2"
                defaultMessage="Are you ready to swap?"
              />
            }
          />
          <FlexedContainer>
            <Cards className="confirm">
              <CardWithLabel>
                <Label>
                  <FormattedMessage
                    id="CardSwap.ConfirmSwap.tradingIn"
                    defaultMessage="Trading in"
                  />
                </Label>
                {renderCardToSwap}
              </CardWithLabel>
              <CardWithLabel>
                <Label>
                  <FormattedMessage
                    id="CardSwap.ConfirmSwap.receiving"
                    defaultMessage="Receiving"
                  />
                </Label>
                {renderCardToReceive}
              </CardWithLabel>
            </Cards>
          </FlexedContainer>
        </>
      }
      footer={
        <>
          <Button
            size="large"
            color="tertiary"
            onClick={async () => {
              await completeTrade!(cardIdToReceive);
              nextStep();
            }}
          >
            <FormattedMessage
              id="CardSwap.ConfirmSwap.swapCta"
              defaultMessage="Swap"
            />
          </Button>

          <FormattedMessage
            id="CardSwap.ConfirmSwap.warning"
            defaultMessage="Warning, this can't be undone"
          />
        </>
      }
    />
  );
};
